// async function loadQuoteForm(form_id) {

//   const url = new URL(`${DCL.site_url}/wp-admin/admin-ajax.php`);
//   const params = {
//     action: "get_form",
//     form_id: form_id,
//   };

//   Object.keys(params).forEach((key) =>
//     url.searchParams.append(key, params[key])
//   );

//   const response = await fetch(url, {
//     method: "GET",
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       console.log("Form loaded.");
//       return data;
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });

//   return response;
// }

// function setup({ el }) {
//   const context = el;
//   const selectors = {
//     trigger: "[data-trigger-quote]",
//     select: "[data-form-select]",
//     modal: "#modal-form",
//     modalContent: "[data-micromodal-content]",
//   };
//   const elements = {
//     trigger: context.querySelector(selectors.trigger),
//     select: context.querySelector(selectors.select),
//     modal: document.querySelector(selectors.modal),
//     modalContent: document.querySelector(selectors.modalContent),
//   };

//   elements.trigger.addEventListener("click", async () => {
//     const form_id = elements.select.selectedOptions[0].dataset.formId;
//     const form = await loadQuoteForm(form_id);

//     elements.modalContent.innerHTML = form.data;

//     MicroModal.show("modal-form");
//   });
// }

function setup({ el }) {
  const context = el;
  const selectors = {
    trigger: "[data-trigger-quote]",
    select: "[data-form-select]",
    modal: "#modal-form",
    modalContent: "[data-micromodal-content]",
  };

  const elements = {
    trigger: context.querySelector(selectors.trigger),
    select: context.querySelector(selectors.select),
    modal: document.querySelector(selectors.modal),
    modalContent: document.querySelector(selectors.modalContent),
  };

  elements.trigger.addEventListener("click", () => {
    const selectedItem = elements.select.selectedOptions[0];
    const form_url = selectedItem.dataset.formPage;
    const hasHash = selectedItem.dataset.hash === 'true';
    window.location.replace(`${form_url}${hasHash ? '#form' : ''}`);
  });
}

function init() {
  document.querySelectorAll("[data-module='form-quote']").forEach((el) => {
    setup({ el });
  });
}

export default init;
